import { render, staticRenderFns } from "./BusinessCommentListModal.vue?vue&type=template&id=1ed46cfb&"
import script from "./BusinessCommentListModal.vue?vue&type=script&lang=js&"
export * from "./BusinessCommentListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports